export interface ReadingStats {
  ebookFirstDate: number;
  ebookLastDate: number;
  ebookTimeReading: number;
  ebookPagesRead: number;
  ebookReadingPercentage: number;
  ebookSource: string[];
  ebookTitle: string;
  recordId: string;
  totalEbooks: number;
  totalTime: number;
  totalPages: number;
  minutesReadByHourInLast30days: number[];
}

export interface MediaStats {
  firstDate: number;
  lastDate: number;
  totalReproduced: number;
  source: string[];
  title: string;
  recordId: string;
  totalMedia: number;
  totalTime: number;
  minutesPlayedByHourInLast30days: number[];
}

export interface UserStatsBundle {
  readingStats: ReadingStats;
  listeningStats: MediaStats;
  watchingStats: MediaStats;
  scormStats: MediaStats;
}

export interface LastUsage {
  title: string;
  firstDate: string;
  lastDate: string;
  lastDedicatedHours: string;
  lastUnitsPerHour?: number | string;
}

export interface TotalUsage {
  totalItems: number;
  totalDedicatedHours: string;
  totalUnitsPerHour?: number | string;
}

export const mobileIcons = ['first_access', 'last_access', 'clock', 'speed'];
export const mobileLabels = [
  'user.stats.firstAccess',
  'user.stats.lastAccess',
  'user.stats.dedicatedHours',
  'user.stats.pagesHour',
];
